
import themes from "@/mixins/themes"
import JobSlideShowV3 from "@/components/job/jobpage/JobSlideShowV3"
import JobContainer from "@/components/job/jobpage/JobContainer"
import intersection from "@/directives/intersection"

export default {
    name: "Section3",
    components: {
        JobContainer,
        JobSlideShowV3,
    },
    directives: {
        intersection,
    },
    mixins: [themes],
    props: {
        /** Array of images and videos */
        mediaList: {
            type: Array,
            default: () => [],
        },
    },
    inject: ["editorMode"],
    computed: {
        hasMedia() {
            return this.mediaList.length > 0
        },
    },
    methods: {
        onShowMore(medium) {
            this.$fullscreenMedia.open(this.mediaList, { initialId: medium.id })
        },
    },
}
